import api from './baseApi';
import { ImageFormats, SignedUrlImageType, SignedUrlResponse, ThumbnailResponse } from './typings/image';

export const getImageUploadS3SignedUrl = async (
    type: SignedUrlImageType,
    format: ImageFormats
): Promise<SignedUrlResponse> => {
    const response = await api.get('/Images/ImageUploadSignedUrl', {
        params: {
            type: type,
            format: format
        }
    });
    return response.data;
};

export const generateImageThumbnail = (filename: string, type?: SignedUrlImageType): Promise<ThumbnailResponse> =>
    api.get(`/Images/Thumbnail/${encodeURIComponent(filename)}`, { params: { type } }).then(({ data }) => data);

export const getProductThumbnailsS3SignedUrl = async (): Promise<SignedUrlResponse> => {
    const response = await api.get('/Images/ProductThumbnail/SignedUrl');
    return response.data;
};
